import { connect } from 'react-redux';
import qs from 'qs';

import {
  findPurchase,
  fetchUserPurchases,
  fetchSpecificUserPurchases,
  mergePurchases,
} from 'actions/purchases';
import MergePurchases from 'components/MergePurchases/MergePurchases';

import {
  getUserPurchases,
  getSpecificUserPurchases,
  getPageCount,
} from 'reducers';
import { searchUsers } from 'actions/users';
import { getSearchUsers } from 'reducers';

const mapStateToProps = (state, { location: { search } }) => {
  const { page = 1, otherUserPage = 1 } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });
  return {
    purchases: getUserPurchases(state, page),
    pageCount: getPageCount(state, 'purchases', `fetchByUser`, page),
    otherUserPurchases: getSpecificUserPurchases(state, otherUserPage),
    otherUserPageCount: getPageCount(
      state,
      'purchases',
      `fetchSpecificByUser`,
      otherUserPage,
    ),
    users: getSearchUsers(state),
    page,
    otherUserPage,
  };
};

const mapDispatchToProps = {
  findPurchase,
  fetchUserPurchases,
  fetchSpecificUserPurchases,
  searchUsers,
  mergePurchases,
};

export default connect(mapStateToProps, mapDispatchToProps)(MergePurchases);
